/**
 * GET forms: temporarily disable empty named fields so they are omitted from the query string.
 * @returns {HTMLElement[]} fields that were disabled — pass to reenableGetFormFields after submit.
 */
export function disableEmptyGetFormFields(form) {
  const temporarilyDisabled = []
  if ((form.method || "").toLowerCase() !== "get") return temporarilyDisabled

  form.querySelectorAll("input[name], textarea[name], select[name]").forEach((field) => {
    if (field.type === "checkbox" || field.type === "radio" || field.type === "file") return
    if (field.value === "" && !field.disabled) {
      field.disabled = true
      temporarilyDisabled.push(field)
    }
  })
  return temporarilyDisabled
}

export function reenableGetFormFields(temporarilyDisabled) {
  temporarilyDisabled.forEach((field) => {
    field.disabled = false
  })
}

/**
 * requestSubmit after stripping empty GET params. Safe to call synchronously after disable;
 * the browser snapshots field disabled state when building the submission.
 */
export function submitGetFormTrimmed(form) {
  const temporarilyDisabled = disableEmptyGetFormFields(form)
  try {
    form.requestSubmit()
  } finally {
    reenableGetFormFields(temporarilyDisabled)
  }
}
